module.exports = __webpack_public_path__ + "img/9-04.4e3a5ffe.png";